export class DataLayerStaticData {
    public static readonly ERROR_AREA: string = 'AWO';
    public static readonly BUSINESS_UNIT: string = 'B2C';
    public static readonly PRODUCT_BRAND: string = 'Altibox';
    public static readonly SERVICE_CATEGORY: string = 'Wifi';
    public static readonly EQUIPMENT_CATEGORY: string = 'Hardware';
    public static readonly ITEM_PRODUCT_TYPE: string = 'altibox-wifi-overalt';
    public static readonly FUNNEL_STEP: string = 'self_service_funnel';
}
